import React, { Component } from 'react';
import Dialog from '../../common/Dialog';
import InputText from '../../common/Form';
import { normalizeStr } from '../../../utils/generalFuncs';
import { isEmpty } from "lodash";
import Creatable from '../../common/Creatable';

class SalaryCatForm extends Component {
    state = { 
        salary_cat_name: this.props.salary_cat_name || "",
        salary_cat_rate: "",
        salary_cat_parent: "",
        salary_cat_parentDisplay: {},
        errors:{
            salary_cat_name: "",
            // salary_cat_rate: "",
            salary_cat_parent: "",
        }
     }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        this.setState({
            [name]: value
        })
    }
    handleChangeCat = (option) => {
        if(option){
            this.setState({
                salary_cat_parent: option.value || "",
                salary_cat_parentDisplay: option
            })
        } else {
            this.setState({
                salary_cat_parent: "",
                salary_cat_parentDisplay: {}
            })
        }
    }
    
    nameExist = (name, id) => {
        const { SALARY_CATS } = this.props;
        let list = []
        
        list = Object.values(SALARY_CATS).filter(cat => ( 
                (normalizeStr(cat.salary_cat_name) === normalizeStr(name) ) && 
                (cat.salary_cat_id !== id) 
            ) )

        console.log("Category exist",{list});

        return !isEmpty(list)
    }
    validate = () => {
        let errors = {}
        let required = [
            "salary_cat_name",
            "salary_cat_parent"
        ]
        let noErrors = true
        required.forEach( field => {
            if(isEmpty(this.state[field])){
                errors[field] = "Veuillez remplir ce champ"
                noErrors = false
            } else {
                errors[field] = ""
            }
        })
        this.setState({
            errors
        })
        return noErrors
    }
    handleSubmit = async  () => {
        if (!this.validate()) {
            this.props.notif("error", "Le formulaire contient des erreurs")
        } else if( this.nameExist(this.state.salary_cat_name) ) {
            this.props.notif("error", "Cette rubrique existe déja")
        } else {
            let data = {
                salary_cat_name: this.state.salary_cat_name.trim(),
                salary_cat_rate: parseFloat(this.state.salary_cat_rate),
                salary_cat_parent: this.state.salary_cat_parent
            }
            console.log('=============Submit salary cat=======================');
            console.log({data});
            console.log('====================================');
            await this.props.newSalaryCat(data)

            if(this.props.STATE.salary_cats.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.salary_cats.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        }
    }
    
    render() {
        const { CATEGORIES } = this.props;
        return (
            <Dialog
                open={true}
                title="Nouvelle Rubrique"
                close={this.props.handleClose}
                submitAction={this.handleSubmit}
                disabledSubmit={this.props.STATE.salary_cats.fetching}
            >
                <InputText 
                    required
                    name="salary_cat_name"
                    value={this.state.salary_cat_name}
                    error={this.state.errors.salary_cat_name}
                    onChange={this.handleChange}
                    label="Intitulé"
                />
                <InputText 
                    name="salary_cat_rate"
                    label="Taux"
                    value={this.state.salary_cat_rate}
                    // error={this.state.errors.salary_cat_rate}
                    onChange={this.handleChange}
                    type="number"
                />
                <Creatable
                    label="Classe Comptable"
                    required
                    error={this.state.errors.salary_cat_parent}
                    id="salary_cat_parent"
                    options={Object.values(CATEGORIES.CHILD).filter(c => c.is_active !== false).map( item => ({
                        label: `${item.category_accounting_id} - ${item.category_name}`,
                        // label: item.category_name,
                        value: item.category_id
                    }))}
                    value={this.state.salary_cat_parentDisplay}
                    openPopUp={this.props.createNewCategory}
                    onChange={this.handleChangeCat}
                    // {...this.props}
                />
                {/* <InputSelectNative
                    required
                    label="Classe Comptable"
                    name="salary_cat_parent"
                    onChange={this.handleChange}
                    error={this.state.errors.salary_cat_parent}
                    value={this.state.salary_cat_parent}
                    options={ Object.keys(CATEGORIES.PARENT).map( category  => (
                        <optgroup key={category} label={CATEGORIES.NAMES[category].category_name}>
                            {CATEGORIES.ALL[category] && CATEGORIES.ALL[category].map( subcat => (
                                <option value={subcat} key={subcat} 
                                // className={classes.selectOption}
                                >
                                    {CATEGORIES.CHILD[subcat] && CATEGORIES.CHILD[subcat].category_name}
                                </option>
                            ))
                            }
                        </optgroup>
                    )) }
                /> */}
            </Dialog>
        );
    }
}

export default SalaryCatForm;